<template>
  <div>
    <v-card class="">
      <!-- {{ contact }} -->
      <v-card-title class="group-title">
        <div class="group-title">About {{ group.admin.profile.name }}</div>
        <v-spacer></v-spacer>
        <div @click="routeToLogin()">
          <v-btn @click="goToProfile(group.admin)" color="primary" icon>
            <v-icon :small="$vuetify.breakpoint.xsOnly">mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <div class="d-flex align-center">
          <div>
            <div v-if="!group.admin.profile.profile_image" class="user-name">
              <div class="text-center">{{ getName }}</div>
            </div>
            <v-img
              v-else
              class="group-user-img"
              :src="group.admin.profile.profile_image"
            ></v-img>
          </div>
          <div class="cin-sebi ml-3">
            <div v-if="contact.CIN">
              CIN: {{ contact.CIN ? contact.CIN : "-" }}
            </div>
            <div>
              SEBI: {{ contact.SEBI_number ? contact.SEBI_number : "-" }}
            </div>
          </div>
        </div>
        <div class="group-descr mt-4">
          <div v-if="$vuetify.breakpoint.xsOnly">
            <div v-if="!desMore && contact.description.length > 130">
              {{ contact.description.substring(0, 150) }}...
              <span @click="desMore = true" class="show-more"> Show More</span>
            </div>
            <div v-else>
              {{ contact.description }}
              <span
                v-if="contact.description.length > 130"
                @click="desMore = false"
                class="show-more"
                >Read Less</span
              >
            </div>
          </div>
          <div v-else>
            <!-- {{ contact.description ? contact.description : "-" }} -->
            <div v-if="!desMore && contact.description.length > 130">
              {{ contact.description.substring(0, 150) }}...
              <span @click="desMore = true" class="show-more"> Show More</span>
            </div>
            <div v-else>
              {{ contact.description }}
              <span
                v-if="contact.description.length > 130"
                @click="desMore = false"
                class="show-more"
                >Read Less</span
              >
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-text
        v-if="group.admin.profile.show_in_group"
        class="contact-section"
        :class="$vuetify.breakpoint.xsOnly ? 'pb-0' : ''"
      >
        <div class="d-flex">
          <div class="group-contact mb-3">Contact</div>
          <v-spacer></v-spacer>
          <div
            class="text-decoration-underline blue--text show_hide_text"
            @click="toggleDetails"
          >
            {{ showDetails ? "Hide Details" : "Show Details" }}
          </div>
        </div>
        <div class="details" v-if="showDetails">
          <div>
            <span class="contact-title">Address: </span>
            <span class="contact-descr">
              {{ contact.office_address ? contact.office_address : "-" }}
            </span>
          </div>
          <div class="mt-2">
            <span class="contact-title">Telephone: </span>
            <span class="contact-descr"
              >{{ contact.phone ? contact.phone : "" }}
            </span>
          </div>
          <div class="mt-2">
            <span class="contact-title">Email: </span>
            <span class="contact-descr">
              {{ contact.email ? contact.email : "-" }}
            </span>
          </div>
        </div>
        <v-row class="pa-0" justify="center" v-if="showDetails">
          <v-expansion-panels accordion class="pa-0">
            <!-- <v-expansion-panel class="pa-0" @click="viewContactDetail">
              <v-expansion-panel-header class="pl-0"
                >Contact</v-expansion-panel-header
              >
              <v-expansion-panel-content class="officer-div">
                <div>
                  <span class="contact-title">Address: </span>
                  <span class="contact-descr">
                    {{ contact.office_address ? contact.office_address : "-" }}
                  </span>
                </div>
                <div>
                  <span class="contact-title">Telephone: </span>
                  <span class="contact-descr"
                    >{{ contact.phone ? contact.phone : "" }}
                  </span>
                </div>
                <div>
                  <span class="contact-title">Email: </span>
                  <span class="contact-descr">
                    {{ contact.email ? contact.email : "-" }}
                  </span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
            <v-expansion-panel class="pa-0">
              <v-expansion-panel-header class="pl-0"
                >Grievance Officer</v-expansion-panel-header
              >
              <v-expansion-panel-content class="officer-div">
                <div>
                  <span class="contact-title">Name: </span>
                  <span class="contact-descr">
                    {{
                      contact.grievance_officer_name
                        ? contact.grievance_officer_name
                        : "-"
                    }}
                  </span>
                </div>
                <div>
                  <span class="contact-title">Email: </span>
                  <span class="contact-descr">
                    {{
                      contact.grievance_officer_email
                        ? contact.grievance_officer_email
                        : "-"
                    }}
                  </span>
                </div>
                <div>
                  <span class="contact-title">Mobile: </span>
                  <span class="contact-descr">
                    {{
                      contact.grievance_officer_mobile
                        ? contact.grievance_officer_mobile
                        : "-"
                    }}
                  </span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header class="pl-0"
                >Compliance Officer</v-expansion-panel-header
              >
              <v-expansion-panel-content class="officer-div">
                <div>
                  <span class="contact-title">Name: </span>
                  <span class="contact-descr">
                    {{
                      contact.compliance_officer_name
                        ? contact.compliance_officer_name
                        : "-"
                    }}
                  </span>
                </div>
                <div>
                  <span class="contact-title">Email: </span>
                  <span class="contact-descr">
                    {{
                      contact.compliance_officer_email
                        ? contact.compliance_officer_email
                        : "-"
                    }}
                  </span>
                </div>
                <div>
                  <span class="contact-title">Mobile: </span>
                  <span class="contact-descr">
                    {{
                      contact.compliance_officer_mobile
                        ? contact.compliance_officer_mobile
                        : "-"
                    }}
                  </span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>

        <!-- <div class="d-flex align-center">
          <div class="grievance-off">Grievance Officer</div>
          <v-spacer></v-spacer>
          <div>
            <v-btn color="" icon>
              <v-icon>mdi-chevron-right-circle-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex align-center">
          <div class="grievance-off">Compliance Officer</div>
          <v-spacer></v-spacer>
          <div>
            <v-btn color="" icon>
              <v-icon>mdi-chevron-right-circle-outline</v-icon>
            </v-btn>
          </div>
        </div> -->
      </v-card-text>
      <v-card-text class="pt-0">
        <div class="group-contact">Disclaimer</div>
        <div class="disclaimer mt-3">
          {{ group.disclaimer ? group.disclaimer : "-" }}
        </div>
      </v-card-text>
      <v-card-text
        @click="routeToLogin()"
        class="d-flex py-0 pb-2 justify-space-between"
      >
        <div
          @click="openWindow(contact.investor_charter_file)"
          class="d-flex align-center pointer"
        >
          <div class="investor">Investor Charter</div>
          <div>
            <v-btn color="primary" icon>
              <v-icon small>mdi-open-in-new</v-icon>
            </v-btn>
          </div>
        </div>
        <div
          @click="openWindow(contact.investor_complaints_file)"
          class="d-flex align-center pointer"
        >
          <div class="investor">Investor Complaints</div>
          <div>
            <v-btn color="primary" icon>
              <v-icon small>mdi-open-in-new</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { isAuthenticated } from "@/common/commonFunctions.js";
import commonFunctions from "@/common/commonFunctions";
import apiUrl from "@/common/apiUrl";
import newAxios from "@/api/newAxios";
export default {
  name: "premiumContact",
  props: {
    group: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Authentecated: isAuthenticated,
      desMore: false,
      default_user: require("@/assets/images/default_user_photo.png"),
      userDetail: {},
      showDetails: false,
    };
  },
  computed: {
    getName() {
      let name = this.group.admin.profile.name;
      name = name.split(" ");
      if (name[1]) {
        return (
          name[0].slice(0, 1).toUpperCase() + name[1].slice(0, 1).toUpperCase()
        );
      }
      return name[0].slice(0, 1).toUpperCase();
    },
  },
  created() {
    this.getUserDetail();
  },
  methods: {
    openWindow(url) {
      window.open(url);
    },

    routeToLogin() {
      if (!this.Authentecated()) {
        this.$store.dispatch("login/toggleGroupsUserUrl", {
          url: this.$route.params.id,
        });
        this.$router.push({
          name: "login",
        });
      }
    },

    goToProfile(user) {
      if (this.Authentecated()) {
        if (this.group.is_admin) {
          this.$router.push({
            name: "ProfilePage",
          });
        } else {
          this.$router.push({
            name: "OthersProfilePage",
            params: {
              id: user.id,
              name: user.profile.name,
            },
          });
        }
      }
    },
    getUserDetail() {
      const onSuccess = (res) => {
        // console.log(res.data.user_detail.id, "kk");
        this.userDetail = res.data.user_detail;
        let user_detail = res.data.user_detail;
        this.toggleUserDetail({ ...user_detail });
        // console.log(user_detail);
      };
      const onFailure = () => {};
      let params = {};
      params["id"] = commonFunctions.getUserId();
      newAxios("get", apiUrl.ADMIN_PANEL_APIS, {
        params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
    toggleDetails() {
      if (!this.showDetails) {
        this.showDetails = !this.showDetails;
        this.viewContactDetail();
      }
      this.showDetails = !this.showDetails;
    },
    viewContactDetail() {
      this.showDetails = !this.showDetails;
      if (isAuthenticated()) {
        const onSuccess = () => {};
        const onFailure = () => {};
        let data = new FormData();
        data.append("user", this.group.admin.profile.id);
        data.append("my_id", this.userDetail.profile.id);
        newAxios("post", apiUrl.VIEW_CONTACT_DETAIL, {
          data,
          onSuccess,
          onFailure,
          isTokenRequired: true,
        });
      } else {
        const onSuccess = () => {};
        const onFailure = () => {};
        let data = new FormData();
        data.append("user", this.userDetail.profile.id);
        newAxios("post", apiUrl.VIEW_CONTACT_DETAIL, {
          data,
          onSuccess,
          onFailure,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.show_hide_text {
  font-family: Avenir;
  font-size: 16px !important;
  font-weight: 500;
  line-height: 21.86px;
  text-align: right;
  cursor: pointer;
}
@media only screen and (max-width: 768px) {
  .group-title {
    font-family: Avenir;
    font-size: 16px !important;
    font-weight: 800;
    line-height: 21.86px;
    text-align: left;
  }
  .user-name,
  .group-user-img {
    width: 44px !important;
    height: 44px !important;
  }
  .user-name > div {
    font-size: 18px;
  }
  .cin-sebi > div {
    font-family: Avenir;
    font-size: 14px !important;
    font-weight: 500;
    line-height: 19.12px !important;
    text-align: left;
  }
  .group-contact {
    font-family: Avenir;
    font-size: 16px !important;
    font-weight: 800;
    line-height: 21.86px !important;
    text-align: left;
  }
  .contact-title,
  .contact-descr {
    font-family: Avenir;
    font-size: 14px !important;
    // font-weight: 400;
    line-height: 19.12px !important;
    // text-align: left;
  }
  .disclaimer {
    font-family: Avenir;
    font-size: 12px !important;
    font-weight: 400;
    line-height: 16.39px !important;
    text-align: left;
  }
}

::v-deep.theme--light.v-expansion-panels
  .v-expansion-panel:not(:first-child)::after {
  border-color: #fff !important;
}
.show-more {
  color: #2d8cff;
  cursor: pointer;
}
.user-name {
  background-color: #add8e6;
  color: #333333;
  width: 55px;
  height: 55px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-name > div {
  font-size: 22px;
}
.group-title {
  font-family: Avenir;
  font-size: 19px;
  font-weight: 800;
  line-height: 27.32px;
  text-align: left;
  color: #333333;
}
.disclaimer {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.86px;
  text-align: left;
  color: #333333;
}
.group-user-img {
  width: 55px;
  height: 55px;
  border-radius: 8px;
}
.v-expansion-panels {
  z-index: initial !important;
}
.pointer {
  cursor: pointer;
}
.investor {
  font-family: Avenir;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #2d8cff;
}
.group-descr {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.86px;
  text-align: left;
  color: #333333ad;
}
.cin-sebi > div {
  margin: 5px 0;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: left;
  color: #333333;
}
.officer-div > div > div {
  margin-bottom: 7px;
}
.contact-title {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.86px;
  text-align: left;
  color: #333333ad;
}
.contact-descr {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.86px;
  text-align: left;
  color: #333333;
}
.grievance-off {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: left;
  color: #333333;
}
.group-contact {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 800;
  line-height: 27.32px;
  text-align: left;
  color: #333333;
}
.contact-section > div {
  margin: 7px 0;
}
</style>
